export const getUniqueEmails = (emails) => {
  if (!emails.length || !emails) return [];
  return emails.reduce((acc, email) => {
    if (!acc.find((item) => item.value === email.value)) {
      acc.push(email);
    }
    return acc;
  }, []);
};
